export const iconFontAwesomeArrowsChevronDown = (
	<i className="fa-solid fa-chevron-down"></i>
);
